
<script>
import http from '../core/network/http.js';

function printCard(data, model = 'KANBAN_SUPPLY_CHAIN_EXTERNAL.lbx') {
  let d = {
    model,
    data
  }
  return http.post(process.env.PRINT_HEURE_URL + '/api/queue/' + process.env.PRINTER_ID, d)
}

function printFlowrack(data) {
  let d = {'model': 'FLOWLACK_MAGASIN.lbx',
        'data': data}
  return http.post(process.env.PRINT_HEURE_URL + '/api/queue/' + process.env.PRINTER_ID, d)
}

function printDocument (data) {
  const d = {
    model: 'DOCUMENT_THALES.lbx',
    data: data,
  }
  return http.post(process.env.PRINT_HEURE_URL + '/api/queue/' + process.env.PRINTER_ID, d)
}

export default {
    printCard,
    printFlowrack,
    printDocument,
}
</script>



// WEBPACK FOOTER //
// src/api/printHeureServer.vue